// extracted by mini-css-extract-plugin
export default {"icon":"ExampleButton_icon__bNQBH","startIcon":"ExampleButton_startIcon__iw5pm","endIcon":"ExampleButton_endIcon__zbA1J"};